import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DepartmentsSettingsComponent } from './departments-settings.component';
import { AddDepartmentComponent } from './add-department/add-department.component';
import { EditDepartmentComponent } from './edit-department/edit-department.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from 'src/app/material.module';

@NgModule({
  declarations: [
    DepartmentsSettingsComponent,
    AddDepartmentComponent,
    EditDepartmentComponent,
  ],
  imports: [CommonModule, MaterialModule, ReactiveFormsModule, FormsModule],
  exports: [DepartmentsSettingsComponent],
})
export class DepartmentsSettingsModule {}
